import { Link } from "react-router-dom";
import { useT2 } from "@/context/ContentContext";
import { SERVICE_BULLET_COUNT } from "@/data/contentRegistry";

export default function ServicePageShell({ slug }) {
  const { t, img } = useT2();
  const image = img(`${slug}.hero.image`);
  const bulletCount = SERVICE_BULLET_COUNT[slug] || 4;

  return (
    <div data-testid="service-page">
      <section className="relative py-24 md:py-32 border-b border-ducs-gold/10">
        <div className="absolute inset-0 dijon-pattern opacity-30" aria-hidden />
        <div className="relative max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="label-caps mb-5">{t(`${slug}.hero.eyebrow`)}</div>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-ducs-cream leading-tight tracking-tight">
              {t(`${slug}.hero.title.line1`)}<br />
              <span className="text-ducs-gold italic">{t(`${slug}.hero.title.accent`)}</span>
            </h1>
            <div className="gold-divider mt-6" />
            <p className="mt-6 text-ducs-mist text-base md:text-lg leading-relaxed max-w-2xl whitespace-pre-line">
              {t(`${slug}.hero.intro`)}
            </p>
            <div className="mt-10 flex flex-col sm:flex-row gap-3">
              <Link to="/contact" className="btn-primary" data-testid="service-cta-audit">{t(`${slug}.hero.cta1`)}</Link>
              <Link to="/methode" className="btn-secondary" data-testid="service-cta-methode">{t(`${slug}.hero.cta2`)}</Link>
            </div>
          </div>
          {image && (
            <div className="lg:col-span-5">
              <div className="aspect-[5/6] overflow-hidden border border-ducs-gold/20">
                <img src={image} alt="" className="w-full h-full object-cover" />
              </div>
            </div>
          )}
        </div>
      </section>

      <section className="relative py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-5 md:px-8 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="label-caps mb-4">{t(`${slug}.body.eyebrow`)}</div>
            <h2 className="font-serif text-3xl md:text-4xl text-ducs-cream leading-tight whitespace-pre-line">
              {t(`${slug}.body.accent`)}
            </h2>
          </div>
          <div className="lg:col-span-7 grid gap-4">
            {Array.from({ length: bulletCount }).map((_, i) => (
              <div key={i} className="card-ducs p-6 md:p-8">
                <div className="font-serif text-xl text-ducs-gold">{t(`${slug}.bullet${i + 1}.title`)}</div>
                <p className="mt-3 text-ducs-cream/85 leading-relaxed whitespace-pre-line">{t(`${slug}.bullet${i + 1}.body`)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-ducs-navy py-20">
        <div className="max-w-7xl mx-auto px-5 md:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div>
            <div className="label-caps mb-3">{t(`${slug}.cta.label`)}</div>
            <h3 className="font-serif text-2xl md:text-3xl text-ducs-cream max-w-2xl">{t(`${slug}.cta.title`)}</h3>
          </div>
          <Link to="/contact" className="btn-primary" data-testid="service-bottom-cta">{t(`${slug}.cta.button`)}</Link>
        </div>
      </section>
    </div>
  );
}
